import { sanitizeText } from '../string-helpers/formatting.helper';

export function getHeapAttributes(
  telemetryId: string,
  telemetryData?: { [attributeName: string]: string },
) {
  const dataAttributes = {
    'data-heap-id': telemetryId,
  };
  if (telemetryData) {
    Object.keys(telemetryData).forEach((attributeName) => {
      dataAttributes[`data-heap-payload-${sanitizeText(attributeName)}`] =
        telemetryData[attributeName];
    });
  }

  return dataAttributes;
}
